module.exports = __webpack_public_path__ + "static/media/FloraFauna_Categoria_512.ec1bcdec.png";